import React from 'react';
import * as PropTypes from 'prop-types';
import SchoolCheckItem from './SchoolCheckItem';
import styles from './RecoveryGoalSettingReport.module.css';

const propTypes = {
  schools: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  selectedSchoolBids: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
};

function SchoolsChecklist({ schools, selectedSchoolBids, onChange, disabled }) {
  return schools && schools.length > 0 ? (
    <div className={styles['checklist-container']}>
      <ul>
        {schools.map((item) => (
          <SchoolCheckItem
            key={item.bid}
            name={item.name}
            schoolBid={item.bid}
            isChecked={selectedSchoolBids ? selectedSchoolBids.includes(item.bid) : false}
            onChange={onChange}
            disabled={disabled}
          />
        ))}
      </ul>
    </div>
  ) : null;
}

SchoolsChecklist.propTypes = propTypes;
SchoolsChecklist.defaultProps = {
  schools: [],
};
export default SchoolsChecklist;
